import { render, staticRenderFns } from "./CentrosCustos.vue?vue&type=template&id=b4bd0bfa&scoped=true&"
import script from "./CentrosCustos.vue?vue&type=script&lang=js&"
export * from "./CentrosCustos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd0bfa",
  null
  
)

export default component.exports